import { Patient } from 'kb-shared';
import { Consent } from 'screens/InterstitialModal/InterstitialModal.types';
import { pageUrl } from 'utilities/pageUrl';
import { isUS } from 'utilities/userUtil';

export const shouldOpenPatientStateModal = (patient?: Patient) => {
  const isUSPatient = isUS(patient?.address?.country || '');
  const isEmptyState = !patient?.address?.state;

  if (isUSPatient && isEmptyState) {
    return true;
  }

  if (!isUSPatient) {
    return false;
  }
};

export const isOnConsentPage = (requiredConsents: Consent[] = [], locationPathname: string) =>
  requiredConsents.some((c: Consent) => c.linkUrl === locationPathname);

export const isOnConfirmationPage = (locationPathname: string) =>
  locationPathname.startsWith(pageUrl.booking.confirmation());
